var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"head-drop-list"}},[_c('drop-list',{attrs:{"i-class":_vm.iClass,"title":_vm.title,"menu-list":_vm.headList,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }